import { FilterState } from '@/store/useFilterStore';

export const defaultFilterVals: Pick<
    FilterState,
    | 'prefix'
    | 'digits'
    | 'favNum'
    | 'categories'
    | 'operators'
    | 'deviceTypes'
    | 'regionsVal'
    | 'tariffsVal'
    | 'priceMin'
    | 'priceMax'
> = {
    prefix: {
        value: null,
        label: '9**',
    },
    digits: Array(7).fill(''),
    favNum: '',
    categories: [],
    operators: [],
    deviceTypes: [],
    regionsVal: [],
    tariffsVal: [],
    priceMin: '',
    priceMax: '',
};

export const defaultSearchParams = {
    categories: [],
    operators: [],
    device: [],
    regions: [],
    tariffs: [],
    priceMin: '',
    priceMax: '',
};
